export default "__VITE_ASSET__hi91fJAG__"